export { default } from './space';

//# sourceMappingURL=index.js.map